import React from 'react'
import moment from 'moment'
import { users } from '../../../assets'
import {ImageBuffer} from '../..'

import './viewUserAdmin.css'

const ViewUserAdmin = ({details}: any) => {
  return (
    <>
      <div className='view-admin-body-wrapper'>
        <div className='view-admin-body-head'>
          <h3>Admin information</h3>
        </div>
        <div className="view-admin-body-details-wrapper">
          <div className='view-admin-details-title'>
            Image:
          </div>
          <div className='view-admin-details-main'>
            <div className='view-admin-details-image'>
              <ImageBuffer src={`${process.env.REACT_APP_BACKEND_ADMIN_IMAGE_URL}${details?.selectedFile}` || users} alt='Admin image' />
            </div>
          </div>
        </div>
        <div className='view-admin-body-details-wrapper'>
          <div className='view-admin-details-title'>
            First Name:
          </div>
          <div className='view-admin-details-main'>
            {details?.firstName}
          </div>
        </div>

        <div className='view-admin-body-details-wrapper'>
          <div className='view-admin-details-title'>
            Last Name:
          </div>
          <div className='view-admin-details-main'>
            {details?.lastName}
          </div>
        </div>

        <div className='view-admin-body-details-wrapper'>
          <div className='view-admin-details-title'>
            Email Address:
          </div>
          <div className='view-admin-details-main'>
            {details?.emailAddress}
          </div>
        </div>

        <div className='view-admin-body-details-wrapper'>
          <div className='view-admin-details-title'>
            Username:
          </div>
          <div className='view-admin-details-main'>
            {details?.username}
          </div>
        </div>

        <div className='view-admin-body-details-wrapper'>
          <div className='view-admin-details-title'>
            created:
          </div>
          <div className='view-admin-details-main'>
            {moment(details?.createdAt).format('YYYY-MM-DD H:s:m')} 
          </div>
        </div>

        <div className='view-admin-body-details-wrapper'>
          <div className='view-admin-details-title'>
            updated:
          </div>
          <div className='view-admin-details-main'>
            {moment(details?.updatedAt).format('YYYY-MM-DD H:s:m')} 
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewUserAdmin